import {
  CAREER_MENTOR_MESSAGE_TEMPLATE,
  CareerMentorActiveMessageParams
} from './career-mentor-service-types'

export const buildActiveMessageBody = (params: CareerMentorActiveMessageParams) => {
  const args: Record<string, string> = { language: params.language }

  // O template do app não passa pela escolha abaixo: ele é pedido pelo nome e leva argumento
  // próprio. A troca entre os dois de contato existe porque lá o termo de busca decide qual texto
  // a Sofie usa.
  if (params.templateName === CAREER_MENTOR_MESSAGE_TEMPLATE.SEND_APP_LINK) {
    if (params.skillAppUrlParams) args['skill_app_url_params'] = params.skillAppUrlParams

    return { template_name: CAREER_MENTOR_MESSAGE_TEMPLATE.SEND_APP_LINK, args }
  }

  const templateName =
    params.searchTerm &&
    params.templateName === CAREER_MENTOR_MESSAGE_TEMPLATE.CONTACT_REQUEST_FROM_SEARCH
      ? CAREER_MENTOR_MESSAGE_TEMPLATE.CONTACT_REQUEST_FROM_SEARCH
      : CAREER_MENTOR_MESSAGE_TEMPLATE.CONTACT_REQUEST

  if (params.searchTerm) args['search_term'] = params.searchTerm

  return { template_name: templateName, args }
}
